module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Speaker-e2ed7a4c85c0819eb6f38ea285b93e69.svg";